<template>
  <el-dialog :visible.sync="computedVisible"
             :title="title"
             :width="width"
             :fullscreen="fullscreen"
             :modal="modal"
             :modal-append-to-body="modalAppendToBody"
             :append-to-body="appendToBody"
             :lock-scroll="lockScroll"
             :close-on-click-modal="closeOnClickModal"
             :close-on-press-escape="closeOnPressEscape"
             :show-close="showClose"
             :before-close="onBeforeClose"
             :center="center">
    <div v-if="showSlot">
      <slot />
    </div>
    <template v-if="showFooter">
      <span slot="footer"
            class="dialog-footer">
        <slot name="footer"
              v-if="$slots.footer" />
        <template v-if="!$slots.footer">
          <el-button @click="cancel">{{cancelText}}</el-button>
          <el-button type="primary"
                     @click="ok">{{okText}}</el-button>
        </template>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { Dialog, Button } from 'element-ui'
export default {
  components: {
    ElDialog: Dialog,
    ElButton: Button
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '系统提示'
    },
    width: {
      type: String,
      default: '30%'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    center: {
      type: Boolean,
      default: false
    },
    beforeClose: {
      type: Function,
      required: false
    },
    keepAlive: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: '确 定'
    },
    cancelText: {
      type: String,
      default: '取 消'
    }
  },
  data() {
    return {
      showSlot: true,
      slot: {
        footer: false
      }
    }
  },
  computed: {
    computedVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('change', value)
      }
    }
  },
  watch: {
    visible(value) {
      if (this.keepAlive === false) {
        this.showSlot = value
      }
    }
  },
  methods: {
    onBeforeClose(done) {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(done)
      } else {
        done()
      }
    },
    cancel() {
      this.computedVisible = false
      this.$emit('on-cancel')
    },
    ok() {
      this.$emit('on-ok', () => {
        this.computedVisible = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/packages/components/modal/components/main.vue